import { useForm } from 'react-hook-form';
import { useMemo } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { array, object, string } from 'yup';
import { Resolver } from 'react-hook-form';

export const DefaultValues = {
  name: '',
  email: '',
  group: '',
  message: '',
  subject: '',
  positions: [],
  programId: '',
}

function useContactForm() {
  const validationSchema = useMemo(
    () =>
      object().shape({
        name: string().required('Name is required!'),
        email: string().email('Not a valid email!').required('Email is required!'),
        message: string().required('This field is required!'),
        subject: string().required('This field is required!'),
        group: string().required('Missing selected active group account'),
        positions: array().of(string()).required('Positions are required!'),
        programId: string(),
      }),
    []
  );

  return useForm<ContactFormData>({
    defaultValues: DefaultValues,
    resolver: yupResolver(validationSchema) as Resolver<ContactFormData>,
  });
}

export default useContactForm;
